export const WEBSOCKET_API = process.env.REACT_APP_RIVERUS_CLM_WS_API;

// KEYCLOAK
export const KEYCLOAK_URL: string =
  '' + process.env.REACT_APP_RIVERUS_CLM_AUTH_KEYCLOAK_URL;
export const KEYCLOAK_CLIENT_ID: string =
  '' + process.env.REACT_APP_RIVERUS_CLM_AUTH_KEYCLOAK_CLIENTID;
export const APRYSE_LICENSE_KEY =
  '' + process.env.REACT_APP_RIVERUS_CLM_PDFTRON_LICENSE_KEY;
export const MUI_X_LICENSE_KEY = '' + process.env.REACT_APP_MUI_X_LICENSE_KEY;
